import React from 'react'
import AsyncPage from 'pages/AsyncPage'
import log from 'lib/log'
import { loadDrafts } from 'state/actions/drafts'

import universal from 'react-universal-component'
import { useDispatch } from 'react-redux'
import { useCreation } from 'ahooks'
import { bindActionCreators } from 'redux'
const component = universal(props => import('./DraftsPage'))
const ExtraNav = universal(props => import('../MyProfilePageExtraNav'))

export const useDraftsSearchAction = (): { searchAction } => {
  const dispatch = useDispatch()
  const searchAction = useCreation(() => {
    const search = bindActionCreators(loadDrafts, dispatch)
    return ({ filter }) => {
      return search({ filter })
    }
  }, [dispatch])

  return { searchAction }
}

class AsyncDraftsPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const { session: { value: profile } } = getState()
    if (profile) {
      try {
        await loadDrafts({})(dispatch, getState, opts)
      } catch (err) {
        log.error(err)
      }
    }
  }
  // getExtraSecondaryNavigation({ place }) {
  //   return <ExtraNav searchAction={loadDrafts} />
  // }
}

export default new AsyncDraftsPage()
